import {
  baseDarkLightnessConfig,
  royalBluePaletteConfig,
  surfaceDarkLightnessConfig,
} from 'constants/defaultPalette';

export const ripeLemonPaletteConfig = [
  {
    config: baseDarkLightnessConfig,
    hue: 52,
    name: 'primary',
    saturation: 60,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 260,
    name: 'secondary',
    saturation: 32,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 52,
    name: 'tertiary',
    saturation: 10,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 15,
    name: 'error',
    saturation: 40,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 140,
    name: 'success',
    saturation: 70,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 44,
    name: 'warning',
    saturation: 60,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 52,
    name: 'neutral',
    saturation: 10,
  },
  {
    config: surfaceDarkLightnessConfig,
    hue: 52,
    name: 'surface',
    saturation: 10,
  },
];

export const atlantisPaletteConfig = [
  {
    config: baseDarkLightnessConfig,
    hue: 100,
    name: 'primary',
    saturation: 60,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 223,
    name: 'secondary',
    saturation: 60,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 100,
    name: 'tertiary',
    saturation: 10,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 16,
    name: 'error',
    saturation: 60,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 81,
    name: 'success',
    saturation: 40,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 45,
    name: 'warning',
    saturation: 60,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 100,
    name: 'neutral',
    saturation: 2,
  },
  {
    config: surfaceDarkLightnessConfig,
    hue: 100,
    name: 'surface',
    saturation: 8,
  },
];

export const valenciaPaletteConfig = [
  {
    config: baseDarkLightnessConfig,
    hue: 6,
    name: 'primary',
    saturation: 50,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 292,
    name: 'secondary',
    saturation: 10,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 6,
    name: 'tertiary',
    saturation: 28,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 346,
    name: 'error',
    saturation: 40,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 140,
    name: 'success',
    saturation: 40,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 63,
    name: 'warning',
    saturation: 60,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 6,
    name: 'neutral',
    saturation: 10,
  },
  {
    config: surfaceDarkLightnessConfig,
    hue: 6,
    name: 'surface',
    saturation: 8,
  },
];

export const studioPaletteConfig = [
  {
    config: baseDarkLightnessConfig,
    hue: 259,
    name: 'primary',
    saturation: 50,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 37,
    name: 'secondary',
    saturation: 50,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 259,
    name: 'tertiary',
    saturation: 28,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 346,
    name: 'error',
    saturation: 40,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 165,
    name: 'success',
    saturation: 40,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 45,
    name: 'warning',
    saturation: 60,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 259,
    name: 'neutral',
    saturation: 10,
  },
  {
    config: surfaceDarkLightnessConfig,
    hue: 259,
    name: 'surface',
    saturation: 8,
  },
];

export const purpleHeartPaletteConfig = [
  {
    config: baseDarkLightnessConfig,
    hue: 280,
    name: 'primary',
    saturation: 70,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 171,
    name: 'secondary',
    saturation: 50,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 280,
    name: 'tertiary',
    saturation: 28,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 346,
    name: 'error',
    saturation: 40,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 165,
    name: 'success',
    saturation: 40,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 45,
    name: 'warning',
    saturation: 60,
  },
  {
    config: baseDarkLightnessConfig,
    hue: 280,
    name: 'neutral',
    saturation: 10,
  },
  {
    config: surfaceDarkLightnessConfig,
    hue: 280,
    name: 'surface',
    saturation: 1,
  },
];

export const settingsPalette = [
  {
    id: 'royalBlue',
    palette: royalBluePaletteConfig,
  },
  {
    id: 'ripeLemon',
    palette: ripeLemonPaletteConfig,
  },
  {
    id: 'atlantis',
    palette: atlantisPaletteConfig,
  },
  {
    id: 'valencia',
    palette: valenciaPaletteConfig,
  },
  {
    id: 'studio',
    palette: studioPaletteConfig,
  },
  {
    id: 'purpleHeart',
    palette: purpleHeartPaletteConfig,
  },
];
